import React from "react";
import { getImageUrl } from "../../helper/imageHelper";
import { FaGithub, FaGlobe } from "react-icons/fa";

const ProjectCard = ({ title, description, image, link, github_link, category }) => {
  const imageUrl = getImageUrl(image);

  return (
    <div className="w-full p-4 xl:px-12 h-auto xl:py-10 rounded-lg shadow-shadowOne flex flex-col bg-gradient-to-br from-[#fcfcfc] to-[#f6f6f6] dark:from-bodyColor dark:to-[#202327] group hover:bg-gradient-to-b hover:from-gray-100 hover:gray-900 transition-colors duration-1000 border border-gray-100 dark:border-none">
      <div className="w-full h-[80%] overflow-hidden rounded-lg">
        <img
          loading="lazy"
          className="w-full h-60 object-cover object-top group-hover:object-bottom transition-all duration-[5000ms] cursor-pointer"
          src={imageUrl}
          alt={title}
        />
      </div>
      <div className="w-full mt-5 flex flex-col  gap-6">
        <div>
          <div className="flex items-center justify-between">
            <h3 className="text-base uppercase text-designColor font-normal">
              {category}
            </h3>
            <div className="flex gap-2">
              {github_link && (
                <span className="text-lg w-10 h-10 rounded-full bg-black bg-opacity-10 inline-flex justify-center items-center text-gray-500 hover:text-designColor duration-300 cursor-pointer dark:bg-black dark:bg-opacity-25 opacity-70 hover:opacity-100">
                  <a href={github_link} target="_blank" rel="noopener noreferrer">
                    <FaGithub />
                  </a>
                </span>
              )}
              {link && (
                <span className="text-lg w-10 h-10 rounded-full bg-black bg-opacity-10 inline-flex justify-center items-center text-gray-500 hover:text-designColor duration-300 cursor-pointer dark:bg-black dark:bg-opacity-25 opacity-70 hover:opacity-100">
                  <a href={link} target="_blank" rel="noopener noreferrer">
                    <FaGlobe />
                  </a>
                </span>
              )}
            </div>
          </div>
          <h3 className="text-xl md:text-2xl font-bold text-gray-700 dark:text-gray-300 mt-3">
             {title}
           </h3>
          <p className="text-sm tracking-wide mt-3 hover:text-gray-600 duration-300 text-gray-500 dark:text-gray-400">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
